import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from "react-router-dom";
import FromFieldText from '../../../atoms/FromFieldText';
import FromSpFieldTextArea from '../../../atoms/FromSpFieldTextArea';
import { getAllocation, saveComment, getComment } from '../../../services/asset.service';
import * as CryptoJS from "crypto-js";
import FromFieldTextArea from "../../../atoms/FromFieldTextArea";
//import './AssetList.css';
import '../../ExcelUploads/AssetInfo/AssetList.css';
function AddComments() {
    /* ─── Validation Regex (unchanged) ─── */
    const TEXT_REGEX = /^[a-zA-Z0-9-_\/]{1,500}$/;
    const TEXT_SPCL_REGEX = /^[A-Za-z0-9-_.,\/\[\]\-()"'+&'%$#@*!= ]{1,500}$/;

    /* ─── All State (unchanged) ─── */
    const [assetInfo, setAssetInfo] = useState({});
    const [validName, setValidName] = useState(true);
    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);
    const [tag, setTag] = useState('');
    const [ErrTag, setErrTag] = useState(false);
    const [additionalcomments, setAdditionalComments] = useState('');
    const [ErrAdditionalComments, setErrAdditionalComments] = useState(false);

    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const Tag = query.get('tag');
    const comment_id = query.get('comment_ID');

    /* ─── All Functions (unchanged logic) ─── */
    const resetAssetInfo = function () {
        setAssetInfo({});
        setAdditionalComments('');
    }

    const resetAll = function () {
        setTag('');
        setAssetInfo({});
        setAdditionalComments('');
    }

    useEffect(() => {
        if (comment_id !== '' && comment_id !== null) {
            const decryptedBytes = CryptoJS.AES.decrypt(comment_id.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
            const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
            const decryptCommentId = decrypt_data.commentid;
            getCommentInfo(decryptCommentId);
        } else {
            resetAll();
        }
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData = { 'token': EncryptData }
    }, [])

    const getCommentInfo = function (decryptCommentId) {
        resetAssetInfo();
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': { 'comment_id': decryptCommentId },
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData1 = { 'token': EncryptData }
        getComment(oData1).then(function (res) {
            if (res?.data?.data) {
                var aInfo = res.data.data[0];
                setAssetInfo(aInfo);
                setAdditionalComments(aInfo.comment);
                setTag(aInfo.tag);
            } else {
                setErrMsg('TAG comment Not Found');
            }
        })
    }

    const getTagInfo = function () {
        resetAssetInfo();
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': { 'tag': tag },
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData = { 'token': EncryptData }
        getAllocation(oData).then(function (res) {
            var aInfo = {};
            if (res?.data?.data?.assetInfo) {
                setErrMsg('');
                aInfo = res.data.data.assetInfo;
                setAssetInfo(aInfo);
                setTag(aInfo.tag);
            } else {
                setErrMsg('Assets Not Found');
            }
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        var valid_Name = true;
        if (!TEXT_REGEX.test(tag) && tag !== 0) {
            setErrTag('TAG is required');
            valid_Name = false;
        } else {
            setErrTag('');
        }
        if (!TEXT_SPCL_REGEX.test(additionalcomments)) {
            setErrAdditionalComments('Additional comments are required');
            valid_Name = false;
        } else {
            setErrAdditionalComments('');
        }
        if (valid_Name) {
            saveData();
        } else {
            return false;
        }
    }

    const saveData = function (decryptCommentId) {
        if (comment_id !== '' && comment_id !== null) {
            const decryptedBytes = CryptoJS.AES.decrypt(comment_id.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
            const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
            const decryptedCommentId = decrypt_data.commentid;
            var obj = {
                'comment': additionalcomments,
                'tag': tag,
                'comment_id': decryptedCommentId,
                'created_by': sessionStorage.getItem('LoggedInUserId')
            }
        } else {
            var obj = {
                'comment': additionalcomments,
                'tag': tag,
                'created_by': sessionStorage.getItem('LoggedInUserId')
            }
        }
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': obj,
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData = { 'token': EncryptData }
        try {
            saveComment(oData).then(function (res) {
                if ((typeof (res.data.errors) != "undefined") && res.data.errors.errno > 0) {
                    setErrMsg(res.data.message);
                    setSuccess(false);
                } else {
                    setSuccess(res.data.message);
                    resetAssetInfo();
                }
            });
        } catch (err) {
            setSuccess(false);
            if (!err?.data) {
                setErrMsg('No Server Response');
            } else if (err.data?.status === 409) {
                setErrMsg('data already exist');
            } else {
                setErrMsg('Insert/Update Failed');
            }
        }
    }

    /* ─── RENDER ─── */
    return (
        <div className="al-page" id="add-comments-page">

            {/* ══ PAGE HEADER ══ */}
            <div className="al-page-header" id="al-page-header">
                <div className="al-page-header-left">
                    <div className="al-page-header-icon">
                        <i className="bi bi-chat-left-text-fill" />
                    </div>
                    <div className="al-page-header-text">
                        <h5 className="al-page-title">
                            {(comment_id !== '' && comment_id !== null) ? 'Edit Comment' : 'Add Comment'}
                        </h5>
                        <p className="al-page-subtitle">Add or update additional comments for assets</p>
                    </div>
                </div>
            </div>

            {/* ══ ALERTS ══ */}
            {success && (
                <div className="alert alert-success" role="alert" style={{ marginBottom: '16px' }}>
                    <i className="bi bi-check-circle-fill" /> {success}
                </div>
            )}
            {errMsg && (
                <div className="alert alert-danger" role="alert" style={{ marginBottom: '16px' }}>
                    <i className="bi bi-exclamation-triangle-fill" /> {errMsg}
                </div>
            )}

            {/* ══ SEARCH SECTION (if not editing) ══ */}
            {!(comment_id !== '' && comment_id !== null) && (
                <div className="al-filter-card" id="al-search-card">
                    <div className="al-filter-card-header">
                        <span className="al-filter-card-title">
                            <i className="bi bi-search" /> Search Asset by TAG
                        </span>
                    </div>
                    <div className="al-filter-card-body">
                        <div className="al-filter-grid" style={{ gridTemplateColumns: '1fr auto auto', gap: '16px', alignItems: 'flex-end' }}>
                            <div className="al-filter-group">
                                <label className="al-filter-label">Asset TAG <span className="al-required-star">*</span></label>
                                <input
                                    onChange={function (event) { setTag(event.target.value) }}
                                    value={tag}
                                    type="text"
                                    className="al-form-input"
                                    placeholder='Enter the asset TAG'
                                />
                                {ErrTag && <span className="al-field-error"><i className="bi bi-exclamation-circle" /> {ErrTag}</span>}
                            </div>
                            <div className="al-filter-group" style={{ marginBottom: 0 }}>
                                <button onClick={getTagInfo} className='al-btn al-btn-primary'>
                                    <i className="bi bi-search" /> Search
                                </button>
                            </div>
                            <div className="al-filter-group" style={{ marginBottom: 0 }}>
                                <a href={'/add-comments'}>
                                    <button className='al-btn al-btn-outline'>
                                        <i className="bi bi-arrow-clockwise" /> Reset
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ══ FORM CARD ══ */}
            <div className="al-grid-card" id="al-comment-form-card">
                <div className="al-grid-card-header">
                    <span className="al-grid-card-title">
                        <i className="bi bi-chat-square-text" /> Comment Details
                    </span>
                </div>

                <form onSubmit={handleSubmit}>
                    <div style={{ padding: '24px' }}>
                        {/* Asset TAG Display */}
                        <div className="row" style={{ marginBottom: '20px' }}>
                            <div className="col-6">
                                <FromFieldText
                                    label="TAG"
                                    inputValue={assetInfo.tag ? assetInfo.tag : ''}
                                    readOnly="readonly"
                                />
                            </div>
                        </div>

                        {/* Comments Textarea */}
                        <div className="row" style={{ marginBottom: '20px' }}>
                            <div className="col-6">
                                <FromSpFieldTextArea
                                    star="*"
                                    numRows="10"
                                    maxLength="500"
                                    label="Additional Comments"
                                    inputValue={additionalcomments}
                                    setInputValue={setAdditionalComments}
                                    setErrorMsg={ErrAdditionalComments}
                                />
                            </div>
                        </div>

                        {/* Submit Button */}
                        <div className="row" style={{ borderTop: '1px solid #e2e6ef', paddingTop: '24px', marginTop: '24px' }}>
                            <div className="col-12" style={{ textAlign: 'center' }}>
                                {(comment_id !== '' && comment_id !== null) ? (
                                    <button className="al-btn al-btn-primary" style={{ padding: '14px 32px', fontSize: '0.95rem' }}>
                                        <i className="bi bi-pencil-square" /> Update Comment
                                    </button>
                                ) : (
                                    <button className="al-btn al-btn-primary" style={{ padding: '14px 32px', fontSize: '0.95rem' }}>
                                        <i className="bi bi-save2" /> Save Comment
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default AddComments